<div class="control-container">
  @if (show) {
    <div class="loading-spinner"></div>
  }
</div>
